var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{attrs:{"to":_vm.item.link}},[_c('v-list-item-content',{style:(_vm.props.style)},[_c('v-list-item-title',[_vm._v(_vm._s(_vm.item.name))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }